import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'faces-translation',
  templateUrl: './faces-translation.component.html'
})
export class FacesTranslationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
